import React from "react";

function Logo(props: React.HtmlHTMLAttributes<HTMLImageElement>) {
  return <img alt="Logo" src="/static/logo.svg" {...props} />;
}

export default Logo;
